import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Divider, Typography } from 'seagull';
import { billingInitiationTextsPath } from '~/business-logic/billingLogic';
import { TextAndInlineSelectRow } from '~/components/ServiceAdvancedSettings/TextAndInlineSelectRow';
import { useLocaleKeys } from '~/i18n';
import { serviceModel } from '~/models';
import { price } from '~/models/service-cost';
import { AutomaticBillingStages } from './AutomaticBillingStages/AutomaticBillingStages';
import { InlineUpfrontSelect } from './InlineUpfrontSelect/InlineUpfrontSelect';
import { OccurrenceAndTriggerControls } from './OccurrenceAndTriggerControls';
import { useBillingInitiationControl } from './useBillingInitiationControl';
export function AutomaticBillingInitiationControl(props) {
    const { testId, service, disabled, agreementData, isExistingService, onChange = ()=>{}, onBillUpfrontModeChange, isReadOnly } = props;
    const { t: billingInitiationTexts } = useLocaleKeys(billingInitiationTextsPath);
    const controls = useBillingInitiationControl({
        service,
        agreementData,
        isExistingService,
        disabled,
        testId,
        onChange
    });
    const { BillingInitiationControlTestIds, isDisabled, oneTimeInStages, isOngoing, stageScheduleContext } = controls;
    return /*#__PURE__*/ _jsxs("div", {
        "data-testid": BillingInitiationControlTestIds.Root(),
        children: [
            isReadOnly && /*#__PURE__*/ _jsx(Divider, {
                margin: 8
            }),
            /*#__PURE__*/ _jsx(Typography, {
                children: /*#__PURE__*/ _jsxs(TextAndInlineSelectRow, {
                    inline: true,
                    children: [
                        billingInitiationTexts.billed(),
                        " ",
                        /*#__PURE__*/ _jsx(OccurrenceAndTriggerControls, {
                            controls: controls
                        }),
                        isOngoing && onBillUpfrontModeChange && /*#__PURE__*/ _jsx(InlineUpfrontSelect, {
                            service: service,
                            testId: testId,
                            disabled: isDisabled,
                            onChange: onBillUpfrontModeChange
                        })
                    ]
                })
            }),
            oneTimeInStages && /*#__PURE__*/ _jsx(AutomaticBillingStages, {
                testId: testId,
                stages: oneTimeInStages.stages(),
                context: stageScheduleContext,
                valueType: oneTimeInStages.valueType(),
                totalRate: price(service.cost),
                disabled: isDisabled,
                onStagesChange: (stages)=>onChange(serviceModel.setOneTimeInStages(service, oneTimeInStages.setStages(stages))),
                onValueTypeChange: (valueType)=>onChange(serviceModel.setOneTimeInStages(service, oneTimeInStages.setValueType(valueType)))
            })
        ]
    });
}
